import { useState } from 'react';
import RealizationApi from '../../../../../API/shipment/realization-api';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { H2 } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../constans';
import styles from './styles.module.scss';

const MAP_TAB = {
  3: "'02' - реализация ИП Отгрузочное -> Маркетплейс",
  4: "'00' - перепродажа на ИП Гудилина Диана",
  3: "'01' - перепродажа c ИП Гудилина Диана -> ИП Отгрузочное",
}
const MAP_OPERATION = {
  2: 'op02',
  4: 'op0',
  3: 'op01',
};

const ResalePopUp = ({ tab = 0, params = {}, close = () => { }, onClickOk = () => { } }) => {
  const [onClicLoad, setOnClickLoad] = useState(true);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Операция {MAP_TAB[tab]}</H2>

      <Row style={{ marginTop: '15px' }}>
        <>
          {tab === 4 && (
            <>
              <>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() =>
                    RealizationApi.reportOp1Op2({
                      data: {
                        ...params,
                        limit: undefined,
                        page: undefined,
                        sortType: undefined,
                        type: 'xlsx',
                        operation_1c: 0,
                      }
                    })
                  }
                  style={{ background: 'rgb(250 255 42 / 58%)' }}
                >
                  Выгрузка для 1С xlsx ОП_00
                </Button>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => {
                    RealizationApi.reportOp1Op2({
                      data: {
                        ...params,
                        limit: undefined,
                        page: undefined,
                        sortType: undefined,
                        type: 'xml',
                        operation_1c: 0, // перепродажа между ип
                      }
                    })
                    setOnClickLoad(false);
                  }}
                  style={{ marginLeft: '10px', background: 'rgb(250 255 42 / 58%)' }}
                >
                  Выгрузка для 1С xml ОП_00
                </Button>{' '}
              </>{' '}
            </>
          )}
          {tab === 3 && (
            <>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() => {
                  RealizationApi.reportOp1Op2({
                    data: {
                      ...params,
                      limit: undefined,
                      page: undefined,
                      sortType: undefined,
                      type: 'xlsx',
                      operation_1c: 1, // перепродажа между ип
                    }
                  })
                }}
                style={{ background: 'rgb(255 161 42 / 58%)' }}
              >
                Выгрузка для 1С xlsx ОП_01
              </Button>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() => {
                  RealizationApi.reportOp1Op2({
                    data: {
                      ...params,
                      limit: undefined,
                      page: undefined,
                      sortType: undefined,
                      type: 'xml',
                      operation_1c: 1, // перепродажа между ип
                    }
                  })
                  setOnClickLoad(false);
                }}
                style={{ marginLeft: '10px', background: 'rgb(255 161 42 / 58%)' }}
              >
                Выгрузка для 1С xml ОП_01
              </Button>{' '}
            </>
          )}
          {tab === 2 && (
            <>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() =>
                  RealizationApi.reportOp1Op2({
                    data: {
                      ...params,
                      limit: undefined,
                      page: undefined,
                      sortType: undefined,
                      type: 'xlsx',
                      operation_1c: 2, // реализация на мп
                    }
                  })
                }
                style={{ background: 'rgb(151 255 42 / 58%)' }}
              >
                Выгрузка для 1С xlsx ОП_02
              </Button>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() => {
                  RealizationApi.reportOp1Op2({
                    data: {
                      ...params,
                      limit: undefined,
                      page: undefined,
                      sortType: undefined,
                      type: 'xml',
                      operation_1c: 2, // реализация на мп
                    }
                  })
                  setOnClickLoad(false);
                }}
                style={{ marginLeft: '10px', background: 'rgb(151 255 42 / 58%)' }}
              >
                Выгрузка для 1С xml ОП_02
              </Button>
            </>
          )}
        </>
      </Row>
      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{
            marginRight: '15px',
          }}
          disabled={onClicLoad}
          onClick={onClickOk}
        >
          Подтвердить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default ResalePopUp;
